export default __webpack_public_path__ + "static/media/December2011.7d399ba0.png";